import React from "react";
import "./Button.css";

const Button = ({ title }) => {
  return (
    <>
      <button className="buttonStyle">{title}</button>
    </>
  );
};

export default Button;
